const DetectionConfigType = Symbol();

export class DetectionConfig {
    [DetectionConfigType]: any;
    readonly highTemperature: boolean;
    readonly highTemperatureRecovery: boolean;
    readonly lowTemperature: boolean;
    readonly lowTemperatureRecovery: boolean;
    readonly missingApplianceData: boolean;
    readonly ignoreDuringGoingOut: boolean;
    readonly notifyHomeApplianceUsage: boolean;
    readonly notifyHomeApplianceNotUsage: boolean;
    readonly notifyMonthlyReport: boolean;

    private constructor(
        highTemperature: boolean,
        highTemperatureRecovery: boolean,
        lowTemperature: boolean,
        lowTemperatureRecovery: boolean,
        missingApplianceData: boolean,
        ignoreDuringGoingOut: boolean,
        notifyHomeApplianceUsage: boolean,
        notifyHomeApplianceNotUsage: boolean,
        notifyMonthlyReport: boolean
    ) {
        this.highTemperature = highTemperature;
        this.highTemperatureRecovery = highTemperatureRecovery;
        this.lowTemperature = lowTemperature;
        this.lowTemperatureRecovery = lowTemperatureRecovery;
        this.missingApplianceData = missingApplianceData;
        this.ignoreDuringGoingOut = ignoreDuringGoingOut;
        this.notifyHomeApplianceUsage = notifyHomeApplianceUsage;
        this.notifyHomeApplianceNotUsage = notifyHomeApplianceNotUsage;
        this.notifyMonthlyReport = notifyMonthlyReport;
    }

    static from(
        highTemperature: boolean,
        highTemperatureRecovery: boolean,
        lowTemperature: boolean,
        lowTemperatureRecovery: boolean,
        missingApplianceData: boolean,
        ignoreDuringGoingOut: boolean,
        notifyHomeApplianceUsage: boolean,
        notifyHomeApplianceNotUsage: boolean,
        notifyMonthlyReport: boolean
    ): DetectionConfig {
        return new DetectionConfig(
            highTemperature,
            highTemperatureRecovery,
            lowTemperature,
            lowTemperatureRecovery,
            missingApplianceData,
            ignoreDuringGoingOut,
            notifyHomeApplianceUsage,
            notifyHomeApplianceNotUsage,
            notifyMonthlyReport
        );
    }

    static fromNothing() {
        return new DetectionConfig(
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false
        );
    }
}

export type DetectionConfigJson = {
    highTemperature: boolean,
    highTemperatureRecovery: boolean,
    lowTemperature: boolean,
    lowTemperatureRecovery: boolean,
    missingApplianceData: boolean,
    ignoreDuringGoingOut: boolean,
    notifyHomeApplianceUsage: boolean,
    notifyHomeApplianceNotUsage: boolean,
    notifyMonthlyReport: boolean
};

export const detectionConfigInitialState = {
    highTemperature: false,
    highTemperatureRecovery: false,
    lowTemperature: false,
    lowTemperatureRecovery: false,
    missingApplianceData: false,
    ignoreDuringGoingOut: false,
    notifyHomeApplianceUsage: false,
    notifyHomeApplianceNotUsage: false,
    notifyMonthlyReport: false
};
